import { Directive, ViewChild } from '@angular/core';
import { getCollaboratorContractTypeLabel } from 'src/app/_enums/business/collaborator-contract-type.enum';
import { getCollaboratorLPPPlanLabel } from 'src/app/_enums/business/collaborator-lpp-plan.enum';
import { getCivilStatusLabel } from 'src/app/_enums/civil-status.enum';
import { getSexEnumLabel } from 'src/app/_enums/sex.enum';
import { getCountryName } from 'src/app/_helpers/nationalities';
import { CollaboratorMetadata } from 'src/app/_types/lead.types';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class CollaboratorMetadataComponentAbstract extends BaseMetadataComponent<CollaboratorMetadata> {
  getSexEnumLabel = getSexEnumLabel;

  getCivilStatusLabel = getCivilStatusLabel;

  getCollaboratorContractTypeLabel = getCollaboratorContractTypeLabel;

  getCollaboratorLPPPlanLabel = getCollaboratorLPPPlanLabel;

  getCountryName = getCountryName;

  displayContractDetails(metadata?: CollaboratorMetadata) {
    return (
      metadata?.contractDetails &&
      (metadata.contractDetails.startDate ||
        metadata.contractDetails.contractType ||
        metadata.contractDetails.function ||
        metadata.contractDetails.occupancyRate !== undefined ||
        metadata.contractDetails.annualAvsSalary !== undefined ||
        metadata.contractDetails.multipleEmployers !== undefined ||
        metadata.contractDetails.thirteenthMonth !== undefined)
    );
  }

  displayPreviousLppDetails(metadata?: CollaboratorMetadata) {
    return (
      metadata?.previousLppDetails &&
      (metadata.previousLppDetails.pensionFund ||
        metadata.previousLppDetails.referenceNumber ||
        metadata.previousLppDetails.estimatedCreditAmount !== undefined ||
        metadata.previousLppDetails.firstName ||
        metadata.previousLppDetails.lastName ||
        metadata.previousLppDetails.email ||
        metadata.previousLppDetails.phone)
    );
  }

  @ViewChild('pdfViewer') viewer!: PdfViewerModalComponent;

  viewFile(key: string) {
    this.userAuthService.getPresignedUrl(key).subscribe((res) => {
      if (res.status === 'SUCCESS') {
        this.viewer.pdfFileUrl = res.data.preSignedUrl;
        this.viewer.openModal();
      }
    });
  }
}
